<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.source data verification summary") }}</h2>
    </div>
  </div>

  <div class="wrapper wrapper-content">

    <!-- Summary Tiles -->
    <div class="row g-3 mb-2">
      <div class="col-md-6">
        <div class="row g-2">
          <div class="col-6">
            <div class="dash-widget total">
              <div class="dash-widget-top">
                <h4>{{ $t('navigations.total sdv items') }}</h4>
                <span class="dash-widget-icon">&#128203;</span>
              </div>
              <h1 class="font-bold">{{ summaryTiles.totalSdvRecords || 0 }}</h1>
            </div>
          </div>

          <div class="col-6 px-0">
            <div class="dash-widget discrepancy">
              <div class="dash-widget-top">
                <h4>{{ $t('navigations.discrepancy') }}</h4>
                <span class="dash-widget-icon">&#9888;</span>
              </div>
              <h1 class="font-bold">{{ summaryTiles.discrepancyCount || 0 }}</h1>
              <!-- <span class="widget-percentage">{{ summaryTiles.discrepancyPercentage || 0 }}%</span> -->
            </div>
          </div>

          <div class="col-6">
            <div class="dash-widget pending">
              <div class="dash-widget-top">
                <h4>Pending</h4>
                <span class="dash-widget-icon">&#9203;</span>
              </div>
              <h1 class="font-bold">{{ summaryTiles.pendingCount || 0 }}</h1>
              <!-- <span class="widget-percentage">{{ summaryTiles.pendingPercentage || 0 }}%</span> -->
            </div>
          </div>

          <div class="col-6 px-0">
            <div class="dash-widget verified">
              <div class="dash-widget-top">
                <h4>{{ $t('navigations.verified') }}</h4>
                <span class="dash-widget-icon">&#10003;</span>
              </div>
              <h1 class="font-bold">{{ summaryTiles.verifiedCount || 0 }}</h1>
              <!-- <span class="widget-percentage">{{ summaryTiles.verifiedPercentage || 0 }}%</span> -->
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="open-queries-card">
          <h4 class="oq-title">SDV Progress by Site</h4>

          <div class="oq-row" v-for="site in openQueriesBySite" :key="site.siteCode
          ">
            <span class="oq-site">{{ site.siteCode }}</span>
            <div class="oq-bar-track">
              <div class="oq-bar-fill" :style="{ width: site.percentage + '%' }"></div>
            </div>
            <span class="oq-count">{{site.percentage + '%'}}</span>
          </div>
          <div class="oq-footer d-flex justify-content-between">
            <!-- <p class="oq-avg">Avg. time-to-resolution: 4.2 days</p>
            <p class="oq-oldest">Oldest open query: 11 days (SITE-100)</p> -->
          </div>
        </div>
      </div>
    </div>

    <div class="ibox-body mt-3">
      <!--
      <div class="col-lg-12 tabbox px-0">
        <ul class="nav nav-tabs" role="tablist">
          <li>
            <a :class="{ activeTab: showBlock[0] === true }" @click="(showBlock[0] = true), (showBlock[1] = false)"
              @click.prevent="selectDataSignalTab()" data-toggle="tab">
              DataSignal SDV
            </a>
          </li>
          <li>
            <a :class="{ activeTab: showBlock[1] === true }" @click="(showBlock[1] = true), (showBlock[0] = false)"
              @click.prevent="selectFormSdvTab()" data-toggle="tab">Form SDV</a>
          </li>
        </ul>
      </div>
      -->

      <!-- Filters -->
      <div class="ibox-content mb-1 px-3 py-2">
        <div class="form-group mb-1">
          <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
            <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
              <label class="mb-0">{{ $t("navigations.site code") }}</label>
              <select class="form-select my-md-2 my-lg-0" v-model="searchData.SiteId">
                <option value="">{{ $t("navigations.all") }}</option>
                <option v-for="site in sites" :key="site.siteID" :value="site.siteID">
                  {{ site.siteCode }}
                </option>
              </select>
            </div>
            <!-- <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
              <label class="mb-0">{{ $t("navigations.assigned from") }}</label>
              <input type="date" v-model="searchData.FromDate" class="form-control my-md-2 my-lg-0" />
            </div>
            <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
              <label class="mb-0">{{ $t("navigations.assigned to") }}</label>
              <input type="date" v-model="searchData.ToDate" class="form-control my-md-2 my-lg-0" />
            </div> -->
            <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
              <label class="mb-0">{{ $t("navigations.status") }}</label>
              <select class="form-select my-md-2 my-lg-0" v-model="searchData.Status">
                <option value="">{{ $t("navigations.all") }}</option>
                <option value="Discrepancy">{{ $t("navigations.discrepancy") }}</option>
                <option value="Pending">{{ $t("navigations.pending") }}</option>
                <option value="Verified">{{ $t("navigations.verified") }}</option>
              </select>
            </div>
            <span @click.prevent="search()" class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end">
              {{ $t("navigations.search") }}
            </span>
          </div>
        </div>
      </div>

      <!-- DataSignal SDV Tab (commented out - Form SDV only for now)
      <div v-if="showBlock[0]">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">DataSignal SDV List</h5>
        </div>
        <div class="ibox-content">
          <template v-if="showTableLoading === true">
            <div class="text-center">
              <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
              <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
            </div>
          </template>
          <template v-else>
            <div class="text-center" v-if="sdvList.Data.length === 0">
              {{ $t('navigations.no data available') }}
            </div>
            <div v-else class="table-responsive">
              <table class="table table-striped table-bordered dataTables">
                <thead>
                  <tr>
                    <th>{{ $t("navigations.signalId") }}</th>
                    <th>{{ $t("navigations.source") }}</th>
                    <th>{{ $t("navigations.flagged as") }}</th>
                    <th>{{ $t("navigations.assigned by") }}</th>
                    <th>{{ $t("navigations.assigned date") }}</th>
                    <th>{{ $t("navigations.status") }}</th>
                    <th class="text-center">{{ $t("navigations.actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sdv in sdvList.Data" :key="sdv._id">
                    <td>{{ sdv.SignalId }}</td>
                    <td>{{ sdv.Source }}</td>
                    <td>{{ sdv.FlagType }}</td>
                    <td>{{ sdv.CreatedUserEmail }}</td>
                    <td>{{ filter(sdv.AssignedAt) }}</td>
                    <td>{{ sdv.Status }}</td>
                    <td
                      v-if="rollsprivilages.includes('SDV Summary Data') || rollsprivilages.includes('SDV Summary View')"
                      class="align-items-center d-flex justify-content-center"
                    >
                      <button class="btn btn-sm btn-outline-secondary action-btn py-0 me-1"
                        @click="openSDVModal(sdv._id, 'doSDV', 'dataSignal')">
                        <i class="fa fa-database"></i> Data
                      </button>
                      <button class="btn btn-sm btn-primary py-0 action-btn"
                        @click="openSDVModal(sdv._id, 'viewSDV', 'dataSignal')">
                        <i class="fa fa-eye me-1"></i> View
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="sdvList.Data.length != 0" class="row mt-1 mx-0">
              <div class="col-lg-12 mx-0 px-0">
                <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                    <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1" active-color="#618bd7"
                      @update:modelValue="loadPage" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      -->

      <!-- Form SDV List (always shown) -->
      <div>
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="mt-1">SDV Records</h5>
        </div>
        <div class="ibox-content">
          <template v-if="showTableLoading === true">
            <div class="text-center">
              <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
              <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
            </div>
          </template>
          <template v-else>
            <div class="text-center" v-if="formSdvList.entities.length === 0">
              {{ $t('navigations.no data available') }}
            </div>
            <div v-else class="table-responsive">
              <table class="table table-striped table-bordered dataTables">
                <thead>
                  <tr>
                    <th class="sort_block" @click="SortFormSelected('siteCode')">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.site code") }}
                        <span>
                          <i class="fa fa-long-arrow-up"
                            :class="{ 'text-primary': formSearchData.SortBy === 'siteCode' && formSearchData.SortOrder === 'asc' }"></i>
                          <i class="fa fa-long-arrow-down"
                            :class="{ 'text-primary': formSearchData.SortBy === 'siteCode' && formSearchData.SortOrder === 'desc' }"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortFormSelected('subjectId')">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.subject id") }}
                        <span>
                          <i class="fa fa-long-arrow-up"
                            :class="{ 'text-primary': formSearchData.SortBy === 'subjectId' && formSearchData.SortOrder === 'asc' }"></i>
                          <i class="fa fa-long-arrow-down"
                            :class="{ 'text-primary': formSearchData.SortBy === 'subjectId' && formSearchData.SortOrder === 'desc' }"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortFormSelected('visitId')">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.visit name") }}
                        <span>
                          <i class="fa fa-long-arrow-up"
                            :class="{ 'text-primary': formSearchData.SortBy === 'visitId' && formSearchData.SortOrder === 'asc' }"></i>
                          <i class="fa fa-long-arrow-down"
                            :class="{ 'text-primary': formSearchData.SortBy === 'visitId' && formSearchData.SortOrder === 'desc' }"></i>
                        </span>
                      </div>
                    </th>
                    <th class="sort_block" @click="SortFormSelected('formName')">
                      <div class="d-flex flex-row justify-content-between">
                        {{ $t("navigations.ecrf") }}
                        <span>
                          <i class="fa fa-long-arrow-up"
                            :class="{ 'text-primary': formSearchData.SortBy === 'formName' && formSearchData.SortOrder === 'asc' }"></i>
                          <i class="fa fa-long-arrow-down"
                            :class="{ 'text-primary': formSearchData.SortBy === 'formName' && formSearchData.SortOrder === 'desc' }"></i>
                        </span>
                      </div>
                    </th>
                    <!-- <th>{{ $t("navigations.form version") }}</th> -->
                    <th>{{ $t("navigations.plan name") }}</th>
                    <th>{{ $t("navigations.plan version") }}</th>
                    <th>{{ $t("navigations.rule") }}</th>
                    <th>{{ $t("navigations.rule no") }}</th>
                    <th>{{ $t("navigations.rule type") }}</th>
                    <th>{{ $t("navigations.trigger type") }}</th>
                    <th>{{ $t("navigations.status") }}</th>
                    <th v-if="rollsprivilages.includes('SDV Summary Data') || rollsprivilages.includes('SDV Summary View')" class="text-center">{{ $t("navigations.actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="sdv in formSdvList.entities" :key="sdv.id">
                    <td>{{ sdv.siteCode }}</td>
                    <td>{{ sdv.subjectNo }}</td>
                    <td>{{ sdv.visitFormName }}</td>
                    <td>{{ sdv.formName }}</td>
                    <!-- <td>{{ sdv.formVersion }}</td> -->
                    <td>{{ sdv.sdvPlanName }}</td>
                    <td>{{ sdv.planVersion }}</td>
                    <td>{{ sdv.ruleName }}</td>
                    <td>{{ sdv.ruleNo }}</td>
                    <td>{{ sdv.ruleType }}</td>
                    <td>{{ sdv.triggerType }}</td>
                    <td>{{ sdv.overallStatus === "InProgress" ? "In Progress" : sdv.overallStatus }}</td>
                    <td v-if="rollsprivilages.includes('SDV Summary Data') || rollsprivilages.includes('SDV Summary View')" class="align-items-center d-flex justify-content-center">
                      <button v-if="rollsprivilages.includes('SDV Summary Data')" class="btn btn-sm btn-outline-secondary action-btn py-0 me-1" @click="openSDVModal(sdv, 'doSDV', 'form')">
                        <i class="fa fa-database"></i> Data
                      </button>
                      <button v-if="rollsprivilages.includes('SDV Summary View')" class="btn btn-sm btn-primary py-0 action-btn" @click="openSDVModal(sdv, 'viewSDV', 'form')">
                        <i class="fa fa-eye me-1"></i> View
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="formSdvList.entities.length != 0" class="row mt-1 mx-0">
              <div class="col-lg-12 mx-0 px-0">
                <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                  <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                    <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1" active-color="#618bd7"
                      @update:modelValue="loadPage" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

    </div>
  </div>
   <SDVModal
      v-if="showSDVModal"
      :sdvRecordId="selectedId"
      :modalType="selectedModalType"
      :fromTab="selectedFromTab"
      @closeModal="closeSDVModal"
      @sdvUpdated="onSdvUpdated"
    />

  <ListSdvQueryModal v-if="showQueryModal" :signalid="selectedId" @closeModal="closeQueryModal" />
</template>

<script src="./SDV_Summary.js"></script>

<style scoped>
.activeTab {
  color: #495057;
  background-color: #d2e6ef !important;
  border-color: #dee2e6 #dee2e6 #fff;
  border-radius: 5px 5px 0px 0px;
}

.tabbox {
  background-color: #f3f3f4;
}
.dash-widget {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  padding: 6px 12px;
  box-shadow: none !important;
  text-align: left;
  position: relative;
  overflow: hidden;
  transition: box-shadow .15s ease, transform .15s ease;
}

.dash-widget:hover {
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.08);
  transform: translateY(-1px);
}

.dash-widget::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}

.dash-widget.total::before       { background: #6366f1; }
.dash-widget.discrepancy::before { background: #e64980; }
.dash-widget.pending::before     { background: #f59e0b; }
.dash-widget.verified::before    { background: #0cb8a8; }

.dash-widget-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.dash-widget h4 {
  color: #0d1f48;
  font-size: 0.9rem;
  margin-bottom: 6px;
}

.dash-widget h1 {
  color: #333;
  font-weight: 700;
  font-size: 18px;
  margin: 0;
}

.dash-widget-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}

.dash-widget.total .dash-widget-icon       { background: rgba(99,102,241,0.10); color: #6366f1; }
.dash-widget.discrepancy .dash-widget-icon { background: rgba(230,73,128,0.10); color: #e64980; }
.dash-widget.pending .dash-widget-icon     { background: rgba(245,158,11,0.10); color: #f59e0b; }
.dash-widget.verified .dash-widget-icon    { background: rgba(12,184,168,0.10); color: #0cb8a8; }

.widget-percentage {
  display: block;
  font-size: 0.75rem;
  color: #999;
  margin-top: 2px;
  font-weight: 500;
}

.dash-widget.discrepancy .widget-percentage { color: #e64980; }
.dash-widget.pending .widget-percentage     { color: #f59e0b; }
.dash-widget.verified .widget-percentage    { color: #0cb8a8; }

.open-queries-card {
  background: #ffffff;
  border: 1px solid #f0e4d4;
  border-radius: 10px;
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
}

.oq-title {
  color: #1e3a5f;
  font-size: 11px;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 14px;
}

.oq-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 5px;
}

.oq-site {
  flex: 0 0 90px;
  font-size: 0.75rem;
  color: #333;
  white-space: nowrap;
}

.oq-bar-track {
  flex: 1 1 auto;
  height: 6px;
  background: #e6e1da;
  border-radius: 6px;
  overflow: hidden;
  min-width: 0;
}

.oq-bar-fill {
  height: 100%;
  background: #b5462f;
  border-radius: 6px;
}

.oq-count {
  flex: 0 0 24px;
  text-align: right;
  font-size: 0.85rem;
  color: #b5462f;
  font-weight: 600;
}

.oq-footer {
  margin-top: 1px;
  border-top: 1px solid #f0e4d4;
  padding-top: 10px;
}

.oq-avg {
  font-size: 0.6rem;
  color: #777;
  margin-bottom: 4px;
}

.oq-oldest {
  font-size: 0.7rem;
  color: #b5462f;
  margin-bottom: 0;
}

@media (max-width: 767.98px) {
  .open-queries-card {
    padding: 14px;
  }
  .oq-site {
    flex-basis: 70px;
    font-size: 0.8rem;
  }
  .oq-count {
    flex-basis: 20px;
    font-size: 0.8rem;
  }
  .oq-title {
    font-size: 0.9rem;
  }
}

@media (max-width: 400px) {
  .oq-row {
    flex-wrap: wrap;
  }
  .oq-site {
    flex-basis: 100%;
    margin-bottom: 4px;
  }
  .oq-bar-track {
    flex-basis: calc(100% - 40px);
  }
}
</style>
